import { ValidationError } from "./errors.js";
export async function hashState(state) {
    const canonicalJson = canonicalStringify(state);
    const digest = await globalThis.crypto.subtle.digest("SHA-256", new TextEncoder().encode(canonicalJson));
    return `sha256:${toHex(new Uint8Array(digest))}`;
}
export function canonicalStringify(value) {
    const issues = [];
    const result = stringifyJsonValue(value, [], issues);
    if (issues.length > 0) {
        throw new ValidationError("Value is not JSON-compatible.", issues);
    }
    return result;
}
export function stableStringify(value) {
    return canonicalStringify(value);
}
function stringifyJsonValue(value, path, issues) {
    if (value === null) {
        return "null";
    }
    if (typeof value === "string") {
        return JSON.stringify(value);
    }
    if (typeof value === "boolean") {
        return value ? "true" : "false";
    }
    if (typeof value === "number") {
        if (!Number.isFinite(value)) {
            issues.push({
                path,
                message: "JSON-compatible numbers must be finite."
            });
            return "null";
        }
        return JSON.stringify(value);
    }
    if (Array.isArray(value)) {
        const items = [];
        for (let index = 0; index < value.length; index += 1) {
            items.push(stringifyJsonValue(value[index], [...path, index], issues));
        }
        return `[${items.join(",")}]`;
    }
    if (isPlainRecord(value)) {
        const properties = [];
        for (const key of Object.keys(value).sort()) {
            properties.push(`${JSON.stringify(key)}:${stringifyJsonValue(value[key], [...path, key], issues)}`);
        }
        return `{${properties.join(",")}}`;
    }
    issues.push({
        path,
        message: `Unsupported JSON value type "${typeof value}".`
    });
    return "null";
}
function isPlainRecord(value) {
    if (value === null || typeof value !== "object") {
        return false;
    }
    const prototype = Object.getPrototypeOf(value);
    return prototype === Object.prototype || prototype === null;
}
function toHex(bytes) {
    return Array.from(bytes, byte => byte.toString(16).padStart(2, "0")).join("");
}
//# sourceMappingURL=hash.js.map